//Node Modules
import axios from 'axios'

//Types
import Info from 'types/info'

const BASE_URL = '/info'

export function info(): Promise<Info> {
  return axios.get<Info>(BASE_URL)
    .then(result => result.data)
}